



























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
class PagEmployeeJobDiaryDetailRequest extends PageRequest {
  warehouseCode: string;
  employeeId: number;
  workOrderTypeCode: string;
  fromDate: Date;
  toDate: Date;
  isWorking: boolean;
  pageSize: number;
  pageNumber: number;
}

@Component({
  components: {},
})
export default class EmployeeJobDiaryDetail extends mixins(ListMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "employeeJobDiaryDetail";
  warehouseName: string = "";
  employeeCode: string = "";
  employeeName: string = "";
  //filters
  pagerequest: PagEmployeeJobDiaryDetailRequest =
    new PagEmployeeJobDiaryDetailRequest();

  get store() {
    return this.$store.state.employeeJobDiaryDetail;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.warehouseName =
        this.$store.state.employeeJobDiary.viewJob.warehouseName;
      this.employeeCode =
        this.$store.state.employeeJobDiary.viewJob.employeeCode;
      this.employeeName =
        this.$store.state.employeeJobDiary.viewJob.employeeName;
      this.pagerequest = this.$store.state.employeeJobDiary.viewJob
        .pagerequest as PagEmployeeJobDiaryDetailRequest;
      this.getpage();
    }
  }
  cancel() {
    this.$store.commit(`${this.namespace}/setCurrentPage`, 1);
    (this.$refs.jobForm as any).resetFields();
    this.$emit("input", false);
  }
  preGetPage() {
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.pageNumber = this.currentPage;
  }

  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/exportEmployeeJobDiaryDetail`,
      data: this.pagerequest,
    });
  }

  columns = [
    {
      title: Util.L("WorkOrder"),
      key: "workOrderName",
      width: 120,
    },
    {
      title: Util.L("Start"),
      key: "startTime",
      width: 170,
      render: (h, params) => {
        if (Util.isNull(params.row.startTime)) return "";
        return h("span", Util.toViewDateString(params.row.startTime));
      },
    },
    {
      title: Util.L("End"),
      key: "endTime",
      width: 170,
      render: (h, params) => {
        if (Util.isNull(params.row.endTime)) return "";
        return h("span", Util.toViewDateString(params.row.endTime));
      },
    },
    {
      title: Util.L("DurationTime"),
      key: "duration",
      align: "right",
      width: 120,
      render: (h, params) => {
        return h("span", Util.toViewNumberString(params.row.duration));
      },
    },
    {
      title: Util.L("RefCode"),
      slot: "objectCode",
      key: "objectCode",
      width: 150,
    },
    {
      title: Util.L("Qty"),
      key: "qty",
      align: "right",
      width: 100,
      render: (h, params) => {
        return h("span", Util.toViewNumberString(params.row.qty));
      },
    },
    {
      title: Util.L("TotalWeight"),
      key: "totalWeight",
      align: "right",
      width: 100,
      render: (h, params) => {
        return h("span", Util.toViewNumberString(params.row.totalWeight));
      },
    },
    {
      title: Util.L("SupporterName"),
      key: "supporterName",
      width: 120
    },
  ];
}
